import { createSelector } from '@ngrx/store';
import { IAppState } from '..';
import { TAiAnalyticsState } from './ai-analytics.models';

export const getState = (state: IAppState) => state.aiAnalytics;
export const getChatUiModel = createSelector(getState, (state: TAiAnalyticsState) => state.chatUiModel);
export const getLastSeparatorText = createSelector(getState, (state: TAiAnalyticsState) => state.lastSeparatorText);
